// extracted by mini-css-extract-plugin
export default {"actions":"CreatePrivateLeague_actions__h8PtN","btn":"CreatePrivateLeague_btn__dLRbJ","hint":"CreatePrivateLeague_hint__D1FyK"};